customPin = function () {
  var observer = new MutationObserver(function (mutations) {
    if ($('.leaflet-marker-icon').length) {
      $(".leaflet-marker-icon").filter(function () {
        var alt = $(this).attr('alt');  // Changed from title to alt
        return alt && alt.toLowerCase().indexOf('coming') !== -1;
      }).attr('src', 'https://cdn.shopify.com/s/files/1/0639/7191/8052/files/svg-terracota.svg?v=1670605490');
    }
  });

  observer.observe(document, { attributes: false, childList: true, characterData: false, subtree: true });
}

jQuery(window).on('load', customPin);